export default __webpack_public_path__ + "static/media/gluten-free.81e7e90b.png";